import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

/* 공통모듈 */
import { SharedModule } from '@app/shared.module';

import { EnglishRoutingModule } from '@english/english-routing.module';
import { EnglishComponent } from '@english/english.component';

import { MainComponent } from '@english/page/main/main.component';
import { HeaderComponent } from '@english/page/main/header/header.component';
import { SubHeaderComponent } from '@english/page/main/sub-header/sub-header.component';
import { FooterComponent } from '@english/page/main/footer/footer.component';
import { ContentsComponent } from '@english/page/contents/contents.component';
import { BoardComponent } from '@english/page/board/board.component';
import { BoardListComponent } from './page/board/board-list/board-list.component';
import { BoardViewComponent } from './page/board/board-view/board-view.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [EnglishComponent, MainComponent, HeaderComponent, SubHeaderComponent, FooterComponent,
    ContentsComponent, BoardComponent, BoardListComponent, BoardViewComponent,
  ],
  imports: [
    NgbModule,
    CommonModule,
    SwiperModule,
    SharedModule,
    EnglishRoutingModule,
  ],
  providers: [
    NgbActiveModal,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ],
  bootstrap: [ EnglishComponent ]
})
export class EnglishModule { }
